//import { PropTypes } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
//import { useParams } from "react-router-dom";
import axios from 'utils/axiosInstance';
import { MyLoading } from "components/atoms/MyLoading";

interface RequestMembershipResponse {
  id: number;
}

const fetchBookclubDetail = async (id: number) => {
  const res = await axios.get(`/api/v1/club_infos/${id}`);
  return res.data;
};

interface BookclubDetailPageProps {
  id: number;
}

declare global {
  interface Window {
    kakao: any;
  }
}

export default function BookclubDetailPage({ id }: BookclubDetailPageProps) {
  const mapRef = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const requestMessage = useRef<HTMLTextAreaElement>(null);

  const { data: club_data, isLoading, isError, error } = useQuery({
    queryKey: ["clubinfo", id],
    queryFn: () => fetchBookclubDetail(id),
    enabled: id !== undefined && id !== null,
    retry: (failureCount, error: any) => {
      return error?.status !== 404; // 404는 재시도 하지 않음
    },
  });

  const { club_info: club, is_member, is_requested_membership } = club_data || {};

  useEffect(() => {
    if (
      club &&
      typeof window.kakao !== "undefined" &&
      mapRef.current &&
      club.location
    ) {
      window.kakao.maps.load(() => {
        const [lat, lng] = club.location.split("x").map(Number);
        console.log('map lat, lng: ', lat, lng);
        const map = new window.kakao.maps.Map(mapRef.current, {
          center: new window.kakao.maps.LatLng(lat, lng),
          level: 4,
        });
        new window.kakao.maps.Marker({
          map,
          position: new window.kakao.maps.LatLng(lat, lng),
          title: club.name,
        });
        setMapLoaded(true);
      });
    }
  }, [club, window.kakao]);

  const requestMembership = async () => {
    let res = null;
    let requestMessage1 = requestMessage.current

    axios.post<RequestMembershipResponse>(`/api/v1/club_infos/${id}/request_membership`, {
      request_msg: requestMessage1?.value
    }).then(response => {
      var data = response.data;
      if(data.message) {
        alert(data.message);
      } else {
        //alert("지원이 완료되었습니다.");
      }
      // 성공 처리
      console.log(response);
    }).catch(error => {
      if (error.response) {
        if (error.response.status === 422) {
          let msg = error.response.data.message_detail || error.response.data.message;
          alert(msg);
        } else {
          console.error("에러 발생:", error.response.data);
          alert(error.response.data);
        }
      } else {
        // 네트워크 오류 처리
        console.error("네트워크 오류 발생:", error);
      }
    });

    if (requestMessage1) requestMessage1.value = '';
    (document.getElementById("apply_modal") as HTMLDialogElement)?.close();
  };

  if (isLoading) {
    return <MyLoading />;
  }

  if (isError) {
    const status = (error as any)?.status;
    if (status === 404) {
      return (
        <div className="p-4 text-left text-red-500">
          요청한 클럽 정보를 찾을 수 없습니다.
        </div>
      );
    }
    return (
      <div className="p-4 text-left text-red-500">
        오류가 발생했습니다: {error.message}
      </div>
    );
  }

  if (!club_data?.club_info) {
    return (
      <div className="p-4 text-center text-gray-500">
        클럽 정보가 비어 있습니다.
      </div>
    );
  }

  return (
    <div className="p-4 flex flex-col gap-8">
      <div className="flex flex-wrap gap-2 mb-4">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">클럽</h2>
          {/* <div className="form-control">
            <input type="text" placeholder="검색어를 입력하세요." className="input input-bordered w-64" />
          </div> */}
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <h1 className="text-2xl font-bold mb-4">{club.name}</h1>
          <p>
            <strong>모임장:</strong> {club.manager_name}
          </p>
          <p>
            <strong>연락처:</strong> {club.tel}
          </p>
          <p>
            <strong>장소:</strong> {club.homepage}
          </p>
          <p>
            <strong>이달의 책:</strong> {club.book_title}
          </p>
          <img
            src={club.book_image_url}
            alt={club.book_title}
            className="w-32 h-44 object-cover mt-4"
          />
        </div>
        {club.location ? (
          <div className="h-80 w-full bg-gray-200" ref={mapRef}>
            {!mapLoaded && (
              <span className="text-gray-500 flex items-center justify-center h-full">
                지도 로딩 중...
              </span>
            )}
          </div>
        ) : (
          <div className="h-80 w-full bg-gray-100 flex items-center justify-center text-gray-500">
            위치 정보가 없습니다.
          </div>
        )}
      </div>

      <div className="border-t pt-4">
        <h2 className="text-xl font-semibold mb-2">후기</h2>
        {/* 후기 목록과 작성 폼은 여기 구현 예정 */}
        <div className="text-gray-500">아직 등록된 후기가 없습니다.</div>
      </div>

      {/* 클럽 지원 버튼과 모달 */}
      {!is_member && !is_requested_membership ? (
        <div className="mt-8">
          <button
            className="btn btn-primary"
            onClick={() => (document.getElementById("apply_modal") as HTMLDialogElement).showModal()}
          >
            클럽에 지원
          </button>
        </div>
      ) : null}

      {is_member ? (
        <p>이미 회원입니다.</p>
      ) : null}

      <dialog id="apply_modal" className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-lg">클럽 지원</h3>

          <div className="mt-4">
            <label className="label">
              <span className="label-text">클럽 지원에 대한 메모</span>
            </label>
            <textarea
              className="textarea textarea-bordered w-full"
              placeholder="지원 동기나 하고 싶은 말을 작성해주세요."
              ref={requestMessage}
            ></textarea>
          </div>

          <div className="mt-4 text-sm text-gray-600 whitespace-pre-line">
            가입한 이후 회원은 자신이 속한 소모임을 1개를 정할 수 있습니다.
            (다른 클럽으로 지원하기 위해서는 지원하신 클럽장이 취소한 후에 다른 소모임을 신청할 수 있습니다.
            이는 지원한 클럽이 여러 개일 경우 생길 수 있는 혼선을 막기 위해서이므로, 클럽장과 충분히 소통하여 지원할 수 있기를 바랍니다.)
          </div>

          <div className="modal-action">
            <form method="dialog" className="flex gap-2">
              <button className="btn">닫기</button>
              <button className="btn btn-primary" onClick={requestMembership}>지원하기</button>
            </form>
          </div>
        </div>
      </dialog>
    </div>
  );
}
